import TablePokerBase from "../table_base/table_poker_base";

const { ccclass, property, menu } = cc._decorator;


@ccclass
@menu('custom/PokerTablePokerBase')
export default class PokerTablePokerBase extends TablePokerBase{
    private static s_curMaxId: number = 0
    @property(cc.SpriteAtlas)
    spriteAtlasPoker: cc.SpriteAtlas = null

    @property(cc.Sprite)
    spriteFace: cc.Sprite = null

    @property(cc.Button)
    button: cc.Button = null

    @property(cc.Node)
    nodeLaiZiTag: cc.Node = null

    @property(cc.Node)
    mask: cc.Node = null

    @property(cc.Node)
    doubleTag: cc.Node = null

    public selected: boolean = false
    public marked: boolean = false
    public disabled: boolean = false
    public real_selected: boolean = false
    public isDouble:boolean=false;
    public selected_time: number = 0
    public real_selected_time: number = 0
    public original_pos: cc.Vec2 = cc.v2(0, 0)
    public original_scale: number = 1
    public original_angle: number = 0
    public original_color: cc.Color = new cc.Color(255, 255, 255, 255)

    private m_customGetSpriteFrameKeyFunc: Function = null

    public get id():number{
        return this.m_id
    }
    private m_id: number = 0

    public get code():number{
        return this.m_code
    }
    private m_code: number = 0

    protected static genId():number{
        return ++PokerTablePokerBase.s_curMaxId
    }

    private m_onTouchStartCallback: Function = null
    private m_onTouchStartCallbackObj: any = null

    private m_onTouchMoveCallback: Function = null
    private m_onTouchMoveCallbackObj: any = null

    private m_onTouchEndCallback: Function = null
    private m_onTouchEndCallbackObj: any = null

    private m_onTouchCancelCallback: Function = null
    private m_onTouchCancelCallbackObj: any = null

    private m_onClickCallback: Function = null
    private m_onClickCallbackObj: any = null

    show(){
        this.node.active = true
    }

    hide(){
        this.node.active = false
    }

    reset(){
        this.m_code = 0
        this.selected = false
        this.real_selected = false
        this.marked = false
        this.disabled = false
        this.selected_time = 0
        this.real_selected_time = 0
    }

    onLoad(){      
        super.onLoad()  
        this.m_id = PokerTablePokerBase.genId() 
        this.spriteFace && (this.original_color = this.spriteFace.node.color)
        this.registClickEvent()     
    }

    onDestroy(){
        super.onDestroy()
        this.unregistClickEvent()
        this.setClickListener(null, null)
        this.setTouchStartListener(null, null)
        this.setTouchMoveListener(null, null)
        this.setTouchEndListener(null, null)
        this.setTouchCancelListener(null, null)
    }

    protected registClickEvent(){
        if(this.button && this.button.node != null){
            
            this.button.node.on('click', this.onClick, this);
            this.button.node.on(cc.Node.EventType.TOUCH_START, this.onTouchStart, this)
            this.button.node.on(cc.Node.EventType.TOUCH_MOVE, this.onTouchMove, this)
            this.button.node.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this)
            this.button.node.on(cc.Node.EventType.TOUCH_CANCEL, this.onTouchCancel, this)
        }  
    }

    protected unregistClickEvent(){
        if(this.button && this.button.node != null){
            this.button.node.off('click', this.onClick, this);
            this.button.node.off(cc.Node.EventType.TOUCH_START, this.onTouchStart, this)
            this.button.node.off(cc.Node.EventType.TOUCH_MOVE, this.onTouchMove, this)
            this.button.node.off(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this)
            this.button.node.off(cc.Node.EventType.TOUCH_CANCEL, this.onTouchCancel, this)
        }  
    }


    protected onClick(event: cc.Button){
        if(this.m_onClickCallback != null){
            this.m_onClickCallback.call(this.m_onClickCallbackObj, this, event)
        }
    }

    protected onTouchStart(event: cc.Event.EventTouch){
        if(this.m_onTouchStartCallback != null){
            this.m_onTouchStartCallback.call(this.m_onTouchStartCallbackObj, this, event)
        }
    }

    protected onTouchEnd(event: cc.Event.EventTouch){
        if(this.m_onTouchEndCallback != null){
            this.m_onTouchEndCallback.call(this.m_onTouchEndCallbackObj, this, event)
        }
    }

    protected onTouchCancel(event: cc.Event.EventTouch){
        if(this.m_onTouchCancelCallback != null){
            this.m_onTouchCancelCallback.call(this.m_onTouchCancelCallbackObj, this, event)
        }
    }

    protected onTouchMove(event: cc.Event.EventTouch){
        if(this.m_onTouchMoveCallback != null){
            this.m_onTouchMoveCallback.call(this.m_onTouchMoveCallbackObj, this, event)
        }
    }    

    setTouchStartListener(callback: Function, tagget?: any){
        this.m_onTouchStartCallback = callback
        this.m_onTouchStartCallbackObj = tagget
    }
    
    setTouchMoveListener(callback: Function, tagget?: any){
        this.m_onTouchMoveCallback = callback
        this.m_onTouchMoveCallbackObj = tagget
    }

    setTouchEndListener(callback: Function, tagget?: any){
        this.m_onTouchEndCallback = callback
        this.m_onTouchEndCallbackObj = tagget
    }

    setTouchCancelListener(callback: Function, tagget?: any){
        this.m_onTouchCancelCallback = callback
        this.m_onTouchCancelCallbackObj = tagget
    }

    setClickListener(callback: Function, tagget?: any){
        this.m_onClickCallback = callback
        this.m_onClickCallbackObj = tagget
    }

    showDouble(show:boolean)
    {
        this.isDouble=show;
    }

    fillPoker(code: number, params?: any){
        this.m_code = code
        this.setFace(code)
    }
    
    showFace(show: boolean){
        this.spriteFace.node.active = show
        this.doubleTag && (this.doubleTag.active=this.isDouble)
    }

    showBack(show: boolean){
        this.spriteBack.node.active = show
        if(show){
            this.onUpdateBack()
        }
    }

    showLaiZiTag(show: boolean){
        this.nodeLaiZiTag && (this.nodeLaiZiTag.active = show || false)
    }

    enableClick(enable: boolean){
        this.button.enabled = enable || false
    }

    setCustomGetSpriteFrameKeyByCodeFunc(func: Function, refreshSpriteNow?: boolean){
        this.m_customGetSpriteFrameKeyFunc = func
        if(refreshSpriteNow){
            if(this.code > 0){
                this.setFace(this.code)
            }
        }
    }

    isTouchAtPoker(touch: cc.Touch): boolean{
        let touchLocalPos = this.node.convertToNodeSpaceAR(touch.getLocation())
        let size = this.node.getContentSize()
        let scaleX = this.node.scaleX        
        let scaleY = this.node.scaleY
        let minX = (this.node.anchorX - 1) * size.width * scaleX
        let maxX = (1 - this.node.anchorX) * size.width * scaleX
        let minY = (this.node.anchorY - 1) * size.height * scaleY
        let maxY = (1 - this.node.anchorY) * size.height * scaleY
        return touchLocalPos.x >= minX && touchLocalPos.x <= maxX && touchLocalPos.y >= minY &&touchLocalPos.y <= maxY
    }

    protected setFace(code: number){
        let key = this.getSpriteFrameKeyByCode(code)
        
        this.spriteFace.spriteFrame = this.getSpriteFrameByName(key)
    }

    protected setPokerGrayColor(gray: boolean){
        if(gray){
            this.spriteFace && (this.spriteFace.node.color = cc.color(128, 128, 128, 255))
        }else{
            this.spriteFace && (this.spriteFace.node.color = this.original_color)
        }
    }

    protected getSpriteFrameKeyByCode(code: number):string{
        if(this.m_customGetSpriteFrameKeyFunc != null){
            return this.m_customGetSpriteFrameKeyFunc(code)            
        }
       
        
        code = code % 13 + 1
        return 'Public_fangkuai_' + code.toString()
    }

    protected getSpriteFrameByName(key: string){
        return this.spriteAtlasPoker.getSpriteFrame(key)
    }
}
